require('es6-promise').polyfill()
import axios from 'axios'
import { logMessage } from '@/helpers/global'
import { METHOD } from './method.config'
import { SERVICES_RESP as servicesResp } from '../../configurations'
import { authErrType } from '../../constants/auth'
import { SERVICES_REQUEST as serReq } from './request.config'
import { checkRequestError } from '../../guards'
import { RequestHelper } from './requester-helper'
import { openSessionLogoutDialog } from '../../actions/app'
import { I_TRADE_ACTION } from '../../constants/i-trade'
import { store } from '@/configurations'
import { iTradeEnv } from '../app-configs/iTrade.env'

axios.defaults.withCredentials = true
export const Requester = Object.entries({
  doSendPostRequest,
  doSendGetRequest,
  doSendPutRequest,
  doSendDeleteRequest
}).reduce((prev, [key, func]) => (prev[key] = handleRequestMiddleware(func), prev), {})

const openErrorDialog = dialogThrottleFunc(openSessionLogoutDialog)

function dialogThrottleFunc(func) {
  let flag = true
  const resetState = () => flag = !flag
  return function (args) {
    const params = Object.assign(args, { resetState })
    if (flag) {
      func(params)
      flag = false
    }
  }
}

function handleRequestMiddleware(func) {
  return function(...args) {
    const [service] = args
    if ((service !== serReq.WIN_VEST) || (service === serReq.WIN_VEST && iTradeEnv?.apis?.winvestorApi)) {
      func(...args)
    }
  }
}

function doSendPostRequest(service, action, params, successHandler, failHandler) {
  logMessage('New request: ' + service + action)
  const requestOptions = {
    method: METHOD.POST,
    url: RequestHelper.createBodyRequest(service, action, params).url,
    headers: RequestHelper.createAuthorizationHeader(service, action, params),
    data: RequestHelper.createBodyRequest(service, action, params).params,
    withCredentials: true,
    credentials: 'include'
  }

  axios(requestOptions)
    .then(response => {
      onResponse(response, successHandler, failHandler)
    })
    .catch(error => {
      failHandler(error)
    })
}

function doSendGetRequest(service, action, params, successHandler, failHandler) {
  logMessage('New request: ' + service + action)
  let method = METHOD.GET;
  const requestOptions = {
    method: METHOD.GET,
    url: RequestHelper.createQueryParamRequest(service, action, params).url,
    headers: RequestHelper.createAuthorizationHeader(service, action, params, method),
    credentials: 'include',
    withCredentials: true
  }

  axios(requestOptions)
    .then(response => {
      onResponse(response, successHandler, failHandler)
    })
    .catch(error => {
      failHandler(error)
    })
}

function doSendPutRequest(service, action, params, successHandler, failHandler) {
  logMessage('New request: ' + service + action)
  const requestOptions = {
    method: METHOD.PUT,
    url: RequestHelper.createBodyRequest(service, action, params).url,
    headers: RequestHelper.createAuthorizationHeader(service, action, params),
    data: RequestHelper.createBodyRequest(service, action, params).params,
    withCredentials: true,
    credentials: 'include'
  }

  axios(requestOptions)
    .then(response => {
      onResponse(response, successHandler, failHandler)
    })
    .catch(error => {
      failHandler(error)
    })
}

function doSendDeleteRequest(service, action, params, successHandler, failHandler) {
  logMessage('New request: ' + service + action)
  const requestOptions = {
    method: METHOD.DELETE,
    url: RequestHelper.createQueryParamRequest(service, action, params).url,
    headers: RequestHelper.createAuthorizationHeader(service, action, params),
    credentials: 'include',
    withCredentials: true
  }

  axios(requestOptions)
    .then(response => {
      onResponse(response, successHandler, failHandler)
    })
    .catch(error => {
      failHandler(error)
    })
}

function onResponse(resp, successHandler = () => {}, failHandler = () => {}) {
  const { data } = resp
  if (
    data.result.errorCode === servicesResp.ANOTHER_PLACE_LOGIN ||
    servicesResp.SESSION_FAILURE.includes(data.result.errorCode) ||
    servicesResp.SESSION_NOT_FOUND.includes(data.result.errorCode)
  ) {
    store.dispatch({
      type: I_TRADE_ACTION.STOP_QUTO_REFRESH,
      stopQutoRefresh: 'true'
    })
    openErrorDialog({ errorCode: data.result.errorCode, errorMessage: data.result.errorMessage })
    failHandler(data)
  } else {
    if (servicesResp.SESSION_FAILURE.includes(data.result.errorCode)) {
      const error = {
        errorCode: data.result.errorCode,
        errorMessage: data.result.errorMessage
      }
      checkRequestError(error, authErrType.EXPIRED_SESSION)
      failHandler(data)
    } else {
      successHandler(data)
    }
  }
}